{
  "version": 1,
  "asset_id": "5d06bac1-ec49-47ac-9b4c-2fe637cc13ec",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/5d06bac1-ec49-47ac-9b4c-2fe637cc13ec/plumbing-thumb.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/5d06bac1-ec49-47ac-9b4c-2fe637cc13ec/plumbing-thumb.webp",
  "original_filename": "plumbing-thumb.webp",
  "size": 1692,
  "content_type": "image/webp",
  "created_at": "2026-06-27T00:31:16Z"
}
